module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_5-9d9960b3e9703ccfe1d6bdc3524bdb20.png";